import useSound from 'use-sound'
import notificationSound from '../assets/sounds/answer-tone.wav'

const useNotificationSound = () => {
    return useSound(notificationSound)
}

export default useNotificationSound
